import { Box, Typography } from "@mui/material";

export default function SafeSummaryTile({
  icon, label, title, value, helper, hint, color = "primary", tone,
  active = false, disabled = false, onClick,
}) {
  const clickable = typeof onClick === "function";
  const palette = {
    primary: "#6657ce", secondary: "#6657ce", success: "#168267",
    warning: "#a46b12", error: "#c83a45", info: "#2675b3", grey: "#687280",
  };
  const accent = palette[tone || color] || color;
  return (
    <Box
      component={clickable ? "button" : "dl"}
      type={clickable ? "button" : undefined}
      className={`safe-summary-tile${clickable ? " safe-summary-filter" : " safe-summary-metric"}`}
      data-safe-summary={clickable ? "filter" : "metric"}
      aria-pressed={clickable ? active : undefined}
      disabled={clickable ? disabled : undefined}
      onClick={clickable ? onClick : undefined}
      style={{ "--safe-metric-accent": accent }}
    >
      <Box className="safe-summary-text">
        <Box className="safe-summary-heading">
          <Typography component={clickable ? "span" : "dt"} className="safe-summary-label">{label || title}</Typography>
          {icon && <Box className="safe-summary-icon" aria-hidden="true">{icon}</Box>}
        </Box>
        <Typography component={clickable ? "span" : "dd"} className="safe-summary-value">{value}</Typography>
        {(helper || hint) && <Typography component={clickable ? "span" : "dd"} className="safe-summary-hint">{helper || hint}</Typography>}
      </Box>
    </Box>
  );
}
